import React from 'react';
import { motion } from 'framer-motion';
import { Crown } from 'lucide-react';
import { TrustBadges } from './TrustBadges';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex flex-col items-center justify-center px-6 py-24 overflow-hidden bg-black" data-id="element-94">
      {/* Background image */}
      <div className="absolute inset-0 bg-cover bg-center opacity-40 pointer-events-none" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/rVATjsP8gcdHTtggaCrsAH/CONCEPTO2_SIN_TEXTO.png)'
    }} data-id="element-95" />
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-muted rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-96" />

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-8" data-id="element-98">
          <div className="inline-flex items-center justify-center p-3 rounded-full bg-gold/10 border border-gold/20 mb-6" data-id="element-99">
            <Crown className="w-6 h-6 text-gold" strokeWidth={1.5} data-id="element-100" />
          </div>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="font-playfair text-5xl md:text-6xl lg:text-7xl font-bold text-gold leading-tight mb-8 tracking-tight" data-id="element-101">
          RECUPERA EL TRONO DE TU VIDA EN 72 HORAS
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-gray-400 font-sans max-w-2xl mx-auto mb-12 leading-relaxed font-light" data-id="element-102">
          El Protocolo Neuro-Estratégico para eliminar la ansiedad de contacto y
          recuperar tu soberanía emocional hoy mismo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} data-id="element-103">
          <a href="https://tutiendadigi.shop/cart/51868811428120:1" target="_blank" rel="noopener noreferrer" className="group relative inline-block px-10 sm:px-14 py-5 sm:py-6 btn-metallic-gold text-charcoal font-sans font-black text-base sm:text-lg tracking-widest rounded-md overflow-hidden transition-all hover:shadow-gold-glow-lg hover:scale-105 duration-300 shadow-lg shadow-gold/30 text-center" data-id="element-104">
            <div className="absolute inset-0 w-full h-full bg-white/25 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-105" />
            <span className="relative z-10" data-id="element-106">QUIERO MI CÓDIGO</span>
          </a>
          <p className="mt-4 text-xs sm:text-sm text-gray-500 font-sans tracking-wide uppercase" data-id="element-107">
            Acceso Inmediato • Privacidad Garantizada
          </p>

          {/* Trust Badges */}
          <div className="mt-8" data-id="element-108">
            <TrustBadges data-id="element-109" />
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2" data-id="element-110">
        <div className="w-[1px] h-16 bg-gradient-to-b from-gold/50 to-transparent" data-id="element-111" />
      </motion.div>
    </section>;
}